<template>
  <div>
    <b-modal
      id="modal-add-file"
      ref="modal-add-file"
      cancel-variant="outline-secondary"
      :title="$t('DEBTIA_ADD_MODULE')"
      no-close-on-backdrop
      hide-footer
      @hidden="resetModuleModal"
    >
      <b-overlay
        id="overlay-background"
        :show="loader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-card
          border-variant="success"
          bg-variant="transparent"
          class="shadow-none module-card"
        >
          <validation-observer ref="refFormObserver">
            <b-form>
              <b-row>
                <b-col
                  sm="12"
                >
                  <b-form-group
                    :label="$t('DEBTIA_TITLE')"
                    label-for="title"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Title"
                      rules="required"
                    >
                      <b-form-input
                        id="title "
                        v-model="title"
                        type="text"
                        :placeholder="$t('DEBTIA_TITLE')"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                >
                  <b-form-group
                    :label="$t('DEBTIA_DESCRIPTION')"
                    label-for="description"
                    class="mb-2"
                  >
                    <b-form-textarea
                      id="textarea-rows"
                      v-model="description"
                      :placeholder="$t('DEBTIA_DESCRIPTION')"
                      rows="8"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                >
                  <b-form-group
                    :label="$t('DEBTIA_FILE')"
                    label-for="description"
                    class="mb-2"
                  >
                    <validation-provider
                      v-slot="{ validate, errors }"
                      name="File"
                      rules="required"
                    >
                      <b-form-file
                        id="file-default"
                        ref="client-file"
                        @change="validate($event)"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                >
                  <b-button
                    variant="primary"
                    type="submit"
                    class="addFileBtn"
                    @click.prevent="validationFileForm"
                  >
                    {{ $t('DEBTIA_SUBMIT') }}
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </b-card>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  // BFormInput,
  // BButton,
  BForm,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BFormFile,
  BFormTextarea,
  BOverlay,
} from 'bootstrap-vue'
import axios from '@axios'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

export default {
  components: {
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BButton,
    BFormFile,
    BFormTextarea,
    BOverlay,
  },
  data() {
    return {
      title: '',
      description: '',
      required,
      loader: false,
    }
  },
  created() {
  },
  methods: {
    validationFileForm() {
      const clientId = this.$route.params.id
      const file = this.$refs['client-file'].files[0]
      const form = new FormData()
      form.append('title', this.title)
      form.append('description', this.description)
      form.append('client_id', clientId)
      form.append('file', file)
      this.$refs.refFormObserver.validate().then(success => {
        if (success) {
          this.loader = true
          const url = '/clients/upload-files'
          axios.post(url, form).then(response => {
            if (response.status === 200) {
              this.title = ''
              this.description = ''
              this.loader = false
              this.$refs['modal-add-file'].hide()
              this.$emit('fileadded', 'true')
            }
          })
        }
      })
    },
    resetModuleModal() {
      this.title = ''
      this.description = ''
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';

  .module-card{
    border: 1px solid #d0d0d0 !important;
    margin-bottom: 10px;
  }
  .addFileBtn {
    width: 100%;
  }
</style>
